import React from 'react';

import {AdditionalEmailConfirmScreen} from 'features/auth';

const AdditionalEmailConfirm: React.FC = () => {
    return <AdditionalEmailConfirmScreen/>;
};

export default AdditionalEmailConfirm;
